module.exports = __webpack_public_path__ + "static/media/Customer-Churn-min.fbe8141a.jpg";